export default __webpack_public_path__ + "static/media/c3.a80ab651.png";